var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_139_3981)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.15663C7.80223 1.15663 1.15663 7.80223 1.15663 16C1.15663 24.1978 7.80223 30.8434 16 30.8434C24.1978 30.8434 30.8434 24.1978 30.8434 16C30.8434 7.80223 24.1978 1.15663 16 1.15663ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7328 14.7198V12.2667C11.7328 11.1351 12.1823 10.0498 12.9824 9.24968C13.7826 8.44952 14.8678 8 15.9994 8C17.131 8 18.2163 8.44952 19.0164 9.24968C19.8166 10.0498 20.2661 11.1351 20.2661 12.2667V14.7198H21.2261C22.3454 14.7198 23.2528 15.6272 23.2528 16.7465V21.9731C23.2528 23.0924 22.3454 23.9998 21.2261 23.9998H10.7728C9.65346 23.9998 8.74609 23.0924 8.74609 21.9731V16.7465C8.74609 15.6272 9.65346 14.7198 10.7728 14.7198H11.7328ZM13.7367 10.0039C14.3368 9.40381 15.1507 9.06667 15.9994 9.06667C16.8481 9.06667 17.6621 9.40381 18.2622 10.0039C18.8623 10.604 19.1994 11.418 19.1994 12.2667V14.7198H12.7994V12.2667C12.7994 11.418 13.1366 10.604 13.7367 10.0039ZM12.251 15.7865C12.256 15.7866 12.2611 15.7867 12.2661 15.7867C12.2711 15.7867 12.2762 15.7866 12.2812 15.7865H19.7177C19.7227 15.7866 19.7277 15.7867 19.7328 15.7867C19.7378 15.7867 19.7428 15.7866 19.7478 15.7865H21.2261C21.7563 15.7865 22.1861 16.2163 22.1861 16.7465V21.9731C22.1861 22.5033 21.7563 22.9331 21.2261 22.9331H10.7728C10.2426 22.9331 9.81276 22.5033 9.81276 21.9731V16.7465C9.81276 16.2163 10.2426 15.7865 10.7728 15.7865H12.251Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_3981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircle);
export default __webpack_public_path__ + "static/media/LockCircle.efc71378636ad1ac11c2db22c1a8df6e.svg";
export { ForwardRef as ReactComponent };